<template>
    <div class="app-container mb-8">
        <p class="headline font-weight-bold text-uppercase text-center py-10">{{$t('questionsAndAnswers')}}</p>
        <div class="d-flex justify-center pb-16">
            <v-expansion-panels focusable multiple class="width-1000">
                <v-expansion-panel
                    v-for="(item,i) in 5"
                    :key="i"
                >
                    <v-expansion-panel-header class="title">Вопрос {{item}}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                        labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
                        laboris nisi ut aliquip ex ea commodo consequat.
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
        <v-btn
                color="main--yellow"
                fab
                x-large
                dark
                depressed
                fixed
                right
                bottom
                class="faq-button"
                @click="faqDialogAction"
        >
            <v-icon>mdi-help</v-icon>
        </v-btn>

        <faq-button-dialog
                :isOpen="faqDialogOpen"
                @close="faqDialogOpen = false"
        ></faq-button-dialog>
    </div>
</template>

<script>

    import ActionAccess from '../../../app-front/mixins/ActionAccess';
    import FaqButtonDialog from '../../../app-front/components/dialogs/FaqButtonDialog';
    import FaqService from '../../../app-front/services/api/FaqService';


    import './faq.scss'

    export default {
        name: "Faq",
        mixins: [ActionAccess],
        components: {FaqButtonDialog},
        data() {
            return {
                metaUrl: '/faq',
                faqDialogOpen: false,
                faqDialogMessage: null,
            }
        },
        methods: {
            getFaqInfo() {
                FaqService.setLocale(this.$store.state.language.appLanguage);
                FaqService.getFaq()
                    .then(res => {

                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            faqDialogAction() {
                this.faqDialogMessage = this.id;
                this.faqDialogOpen = true;
            },

        },

        created() {
            this.getFaqInfo();
        }
    }
</script>

<style scoped>
    .faq-button {
        bottom: 100px;
        right: 100px;
    }
    @media screen and (max-width: 800px) {
        .faq-button {
            bottom: 50px;
            right: 50px;
        }
    }
</style>
